import { unmaskSlash } from "javascripts/webpage/link";

$ ->
  # 検索ボックスのクリックカウント[sp]
  $('.js-search-box').on 'submit', (e) ->
    e.preventDefault()
    onclickcatalyst_clickcount('search_box', 'event7')
    @.setAttribute('action', unmaskSlash(@.getAttribute('action')))
    @.submit()

  $(document).on 'click', '.js-click-count', ->
    onclickcatalyst_clickcount($(@).attr('data-click-area'), $(@).attr('data-event'))

  # 追従メニューを途中から表示
  if $('.js-sticky').length > 0
    sticky = document.getElementsByClassName('js-sticky')[0]
    target = document.getElementsByClassName('js-sticky-target')[0]
    observer = new IntersectionObserver (entries) ->
      for entry in entries
        sticky.classList.toggle('c-sticky--active', !entry.isIntersecting)
    observer.observe(target)
